import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

export default function StatCard({ label, value, delta, icon: Icon, tone = 'teal' }) {
  const toneMap = {
    teal: 'bg-teal-50 text-teal-700 ring-1 ring-teal-100',
    amber: 'bg-amber-50 text-amber-700 ring-1 ring-amber-100',
    slate: 'bg-slate-100 text-slate-700 ring-1 ring-slate-200',
    sky: 'bg-sky-50 text-sky-700 ring-1 ring-sky-100',
    rose: 'bg-rose-50 text-rose-700 ring-1 ring-rose-100',
  };
  const positive = delta != null && delta >= 0;
  return (
    <div className="rounded-2xl bg-white border border-slate-200/80 p-5 card-hover">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[11px] font-medium text-slate-500 uppercase tracking-[0.06em]">{label}</div>
          <div className="mt-2 text-[26px] font-semibold text-slate-900 tracking-[-0.02em] tabular-nums leading-none">{value}</div>
          {delta != null && (
            <div className={`mt-2.5 inline-flex items-center gap-0.5 text-[12px] font-medium tabular-nums ${positive ? 'text-emerald-600' : 'text-rose-600'}`}>
              {positive ? <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={2.5} /> : <ArrowDownRight className="h-3.5 w-3.5" strokeWidth={2.5} />}
              {Math.abs(delta)}%
              <span className="text-slate-400 font-normal ml-1">vs last month</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={`h-10 w-10 rounded-xl grid place-items-center flex-shrink-0 ${toneMap[tone]}`}>
            <Icon className="h-[18px] w-[18px]" strokeWidth={2} />
          </div>
        )}
      </div>
    </div>
  );
}
